import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Pill, fmtDate } from "@/components/hub/Common";
import { ReleaseForm, blankRelease } from "@/components/admin/ReleaseForm";

const bump = (v) => { const p = (v || "0.0.0").split(".").map(Number); p[2] += 1; if (p[2] > 9) { p[2] = 0; p[1] += 1; } if (p[1] > 9) { p[1] = 0; p[0] += 1; } return p.join("."); };

export const ReleasesTab = () => {
  const { t } = useI18n();
  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(null);
  const [formKey, setFormKey] = useState(0);
  const load = () => api.get("/admin/releases").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const saved = () => { setEdit(null); setFormKey((k) => k + 1); load(); };
  const del = async (r) => {
    if (!window.confirm(t("adm.rel_delete_confirm"))) return;
    try { await api.delete(`/admin/releases/${r.id}`); load(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="grid xl:grid-cols-[1.1fr_1fr] gap-6 items-start">
      {edit ? <ReleaseForm key={edit.id} id={edit.id} initial={{ version: edit.version, title: edit.title, summary: edit.summary, published: edit.published, items: edit.items }} onSaved={saved} onCancel={() => setEdit(null)} />
        : <ReleaseForm key={`new-${formKey}-${list[0]?.version}`} initial={blankRelease(bump(list[0]?.version))} onSaved={saved} />}
      <div className="space-y-3" data-testid="admin-releases-list">
        {list.map((r) => (
          <div key={r.id} className="cx-card rounded-xl p-4 flex items-center gap-3" data-testid={`admin-release-${r.version}`}>
            <span className="font-display font-bold text-xl cx-text-grad w-24 shrink-0">V{r.version}</span>
            <div className="min-w-0 flex-1">
              <div className="text-sm text-white truncate">{r.title}</div>
              <div className="text-xs text-slate-500">{r.items.length} · {fmtDate(r.published_at || r.created_at)}</div>
            </div>
            <Pill tone={r.published ? "shipped" : "closed"}>{r.published ? t("adm.rel_published") : t("adm.rel_draft")}</Pill>
            <button data-testid={`admin-release-edit-${r.version}`} onClick={() => setEdit(r)} className="p-2 text-slate-400 hover:text-white"><Pencil className="w-4 h-4" /></button>
            <button data-testid={`admin-release-delete-${r.version}`} onClick={() => del(r)} className="p-2 text-slate-400 hover:text-rose-400"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
